import { useEffect, useState } from 'react'
import isImeComposing from 'lib/dom/isImeComposing'

/**
 * Tracks whether each of `targetKeys` is held down anywhere in the window.
 */
function useKeyPress(targetKeys: Array<string>) {
  const [keys, setKeys] = useState<Record<string, boolean>>({})

  useEffect(() => {
    const setKeyPressed = (key: string, pressed: boolean) => {
      setKeys(prev => (prev[key] === pressed ? prev : { ...prev, [key]: pressed }))
    }

    const downHandler = (e: KeyboardEvent) => {
      if (targetKeys.includes(e.key) && !isImeComposing(e)) {
        e.preventDefault()
        setKeyPressed(e.key, true)
      }
    }

    const upHandler = (e: KeyboardEvent) => {
      if (targetKeys.includes(e.key)) {
        e.preventDefault()
        setKeyPressed(e.key, false)
      }
    }

    window.addEventListener('keydown', downHandler)
    window.addEventListener('keyup', upHandler)

    return () => {
      window.removeEventListener('keydown', downHandler)
      window.removeEventListener('keyup', upHandler)
    }
  }, [targetKeys])

  return targetKeys.map(targetKey => keys[targetKey] || false)
}

export default useKeyPress
